export default __webpack_public_path__ + "static/media/mp3.c40a06cd.svg";